define(function (require) {
	const address = 'address';
	const parcel = 'parcel';
	const asset = 'asset';
	const property = 'property';

	return {
		clearUserLocation() {
			this.usersCurrentCoordinates = null;
		},
		getUsersLocation: function (mapExtent, locateMeTimeout) {

			var timeoutMilliseconds = 10000;//don't request location data more than once per ten seconds

			var geoDataPromise = $.Deferred();
			//set a timeout to resolve the geoDataPromise so we don't get stuck when a user's location is failing to return
			//this was a issue reported by daton specifically on phones.
			locateMeTimeout = locateMeTimeout ? locateMeTimeout : 7500;
			setTimeout(function () {
				geoDataPromise.resolve(false);
			}, locateMeTimeout);
			//grab a copy of the coords just in case they're about to be wiped.
			var tempCoords = $.extend({}, this.usersCurrentCoordinates);
			if (tempCoords && tempCoords.x && tempCoords.y) {//if we have coords, use them
				geoDataPromise.resolve(tempCoords);
			} else {
				//we dont have the coordinates saved. So we need to see if we can access them
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition((geoData) => {//success
						if (geoData.coords) {
							var coords = {
								x: geoData.coords.longitude,
								y: geoData.coords.latitude
							};
							if (this.isPointInExtent(coords, mapExtent)) {
								this.usersCurrentCoordinates = coords;
								geoDataPromise.resolve(this.usersCurrentCoordinates);
								setTimeout(this.clearUserLocation.bind(this), timeoutMilliseconds);
							} else {
								geoDataPromise.resolve(false);
							}
						} else {
							geoDataPromise.resolve(false);
						}

					}, () => {
						//fail
						geoDataPromise.resolve(false);
					}, {
						maximumAge: 10,
						timeout: 7500,	//Setting this to 2 seconds works for literally everyone but FF.
						//FF Needs _at least_ 5 seconds to use location services...even when they are HARDCODED into the config.
						//if we see issues in FF with locate me, my gut would be to bump this up further. it doesn't degrade
						//performance in other browsers, but allows FF to walk the coordinates to the user as slow as it likes.
						enableHighAccuracy: true
					});
				} else {
					geoDataPromise.resolve(false);
				}
			}
			return geoDataPromise;
		},
	}
});